import React from "react";
import ZoyLogo from '../assets/images/zoylogo2.png';

const Footer: React.FC = () => {
  return (
    <footer className="bg-[#0A0A1B] text-white py-10 px-6">
      <div className="container mx-auto flex flex-col md:flex-row justify-between items-start gap-8">
        {/* Left Section - Logo & Address */}
        <div className="md:w-1/3">
          <img src={ZoyLogo} alt="Zoy Logo" className="w-40 mb-4 ml-8" />
          <h3 className="text-lg font-semibold ml-8">Corporate Office</h3>
          <p className="text-sm text-gray-300 leading-relaxed ml-8">
            DBQ Technologies Pvt Ltd, 6th Main Rd, <br />
            Sector 6, HSR Layout, Bengaluru, Karnataka <br />
            560102
          </p>
        </div>

        {/* Right Section - Links */}
        <div className="md:w-2/3 grid grid-cols-2 md:grid-cols-4 gap-8">
          {/* Company */}
          <div>
            <h3 className="text-lg font-semibold">Company</h3>
            <ul className="text-sm text-gray-300 space-y-2 mt-2">
              <li>About Us</li>
              <li>Team</li>
            </ul>
          </div>

          {/* Cities */}
          <div>
            <h3 className="text-lg font-semibold">Our Cities</h3>
            <ul className="text-sm text-gray-300 space-y-2 mt-2">
              <li>Bangalore</li>
              <li>Pune</li>
              <li>chennai</li>
              <li>Hyderabad</li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="text-lg font-semibold">Legal</h3>
            <ul className="text-sm text-gray-300 space-y-2 mt-2">
              <li>Terms & Conditions</li>
              <li>Cancellation Policy</li>
            </ul>
          </div>

          {/* Follow Us */}
          <div>
  <h3 className="text-lg font-semibold">Follow Us</h3>
  <ul className="text-sm text-gray-300 space-y-2 mt-2">
    <li>
      <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer">
        LinkedIn
      </a>
    </li>
    <li>
      <a href="https://x.com/ReachZoy" target="_blank" rel="noopener noreferrer">
        X
      </a>
    </li>
    <li>
      <a href="https://www.instagram.com/reach.zoy?igsh=bXM1NjMyOTJ0Z3Ax" target="_blank" rel="noopener noreferrer">
        Instagram
      </a>
    </li>
  </ul>
</div>

        </div>
      </div>

      {/* Bottom Copyright */}
      <div className="text-center mt-8 text-gray-400 text-sm">
        All Rights are reserved for ZOY ©2025
      </div>
    </footer>
  );
};

export default Footer;
